import { default as ArrowLeftIcon } from '#assets/arrow-left.svg?react';
import { IconButton } from './icon-button/IconButton.tsx';
import type { IconButtonProps } from './types.ts';

export function ArrowLeftButton({ size, title = 'Arrow left', ...buttonProps }: IconButtonProps) {
  return (
    <IconButton title={title} height={size} width={size} {...buttonProps}>
      <ArrowLeftIcon />
    </IconButton>
  );
}
